module.exports = __webpack_public_path__ + "img/T1C_rc_20.23dfada9.png";